<template>
	<div class="edit-profilebox add-new-memberbox savingaccount-formbox">
		<ul class="breadcrumbs-list">
		  <a  @click="backButton"><li>Value Added Services</li></a>
		  <a  @click="backButton"><li>&nbsp;>&nbsp;Goal Sure</li></a>
		  <a  @click="backButton"><li>&nbsp;>&nbsp;Retiro Meter</li></a>
		  <li>&nbsp;>&nbsp;Retiro Meter Form</li>
		</ul>
	    <h4>
	    	<v-img  max-width="170" :src=" retirometerLogo" :lazy-src="retirometerLogo"> </v-img>
	    </h4>
		<div class="edit-profilebox-detail">
			<v-form ref="form" id="saving_account" @submit.prevent class="login-form-box register-page" lazy-validation>
			    <h4>Check how far away your are from reaching your retirement income?</h4>
			    <v-row>
					<v-col xs="4" md="3" class="member_relation_box col">
						<label class="member-label">Member </label>
						<v-select
			                v-model="mainMember"
			                :items="getMembersObject"
			                item-value="id"
			                item-text="name"
			                placeholder="Select"
			                @change="setMainMemberData($event)"
			                max-width="500px"
                            :rules="[v => !!v || 'Field is required']"
			            ></v-select>	
					</v-col>
					<v-col xs="4" md="3" class="member_relation_box col">
						<label class="member-label">DOB </label>
						<div class="dob-box">
							<Datepicker
			                    name="mainMemberDob" 
			                    ref="mainMemberDob"
			                    :v-model="mainMemberDob"
			                    format="dd MMM, yyyy"
			                    placeholdeerr="Select"
			                    :disabledDates="disabledDates"
			                    :value="mainMemberDob"
			                    @selected="calculateMainMemberAge($event)"
			                ></Datepicker>
			            </div>     
					</v-col>
					<v-col xs="4" md="3" class="member_relation_box col">
						<label class="member-label">Age </label>
						<v-text-field placeholder="Age" :v-model="mainMemberAge" :value="mainMemberAge">
						</v-text-field>	
					</v-col>
					<v-col xs="4" md="3" class="member_relation_box col">
						<label class="member-label">Retirement Age </label>
						<div class="dob-box">
			                <v-text-field name="retirementAge" 
			                    ref="retirementAge"
			                    placeholder="Retirement Age"
			                    v-model="retirementAge"  
			                    :rules="[v => !!v || 'Field is required']"
			                ></v-text-field>
			            </div>     
					</v-col>
					<v-col xs="4" md="3" class="member_relation_box col">
						<label class="member-label">Desired Monthly Retirement Income</label>
						<div class="dob-box">
			                <v-text-field name="yourDesiredRetirementIncome" 
			                    ref="yourDesiredRetirementIncome"
			                    placeholder="Desired Retirement Income"
			                    v-model="yourDesiredRetirementIncome"  
			                    @input = "calculateYearToRetirement($event), changeTextFieldEvent($event)" 
			                    :rules="[v => !!v || 'Field is required']"
			                ></v-text-field>
			            </div>     
					</v-col>
					<v-col xs="4" md="3" class="member_relation_box col">
						<label class="member-label">Current Monthly Income</label>
						<div class="dob-box">
			                <v-text-field name="yourCurrentMonthlyIncome" 
			                    ref="yourCurrentMonthlyIncome"
			                    placeholder="Current Monthly Income"
			                    v-model="yourCurrentMonthlyIncome"  
			                ></v-text-field>
			            </div>     
					</v-col>
			    </v-row>
			    <div class="row"><br><br></div>
	            <div class="row">
	            	<h4></h4>
	            	<div class="income_container">
	            		<div class="sync_detils main-sync-heading">
				            <span>Sync details</span>
				            <a @click="syncMemberData()"><v-img max-height="22" max-width="20" :src="syncIcon" ></v-img></a>
				        </div>
					    <section class="your_income_section">
					        <div class="col-md-6">
						        <div class="info_box">
						            <div class="income_title">
						              <h3>Current value of Retirement Savings</h3>
						            </div>
						            <div class="income_date">
						              <!-- <p>Monthly</p> -->
						            </div>
						        </div>
					            <div class="your_ins_price expenses">
						            <div class="text_icon">
						            	<div class="d-flex">
						            		<p>Public Provident Fund/Deposits(FD,RD etc)<div><v-img max-height="15" max-width="15" :src="informationIcon" class="icon_tick" title="Enter current balance in your Public Provident Fund Account/Deposits like FD,RD etc. You can use Auto Sync option to auto update your balance."></v-img></div></p>
						            	</div>
						            </div>
						            <div class="fields">
						                <v-text-field placeholder="₹ 0.00" v-model="currentValueOfRetirementSavingsPPF"  @input="changeTextFieldEvent($event)"></v-text-field>
						            </div>
					            </div>
						        <div class="your_ins_price expenses">
						            <div class="text_icon d-block">
						            	<div class="d-flex">
						            		<div><p class="mb-1">Employee Provident Fund</p></div>
						            		<div><v-img max-height="15" max-width="15" :src="informationIcon" title="Enter current balance in your Employee Provident Fund Account. You can use Auto Sync option to auto update your balance."></v-img></div>
						            	</div>
						            </div>
						            <div class="fields">
						                <v-text-field placeholder="₹ 0.00" v-model="currentValueOfRetirementSavingsEPF"  @input="changeTextFieldEvent($event)"></v-text-field>
						            </div>
						        </div>
						        <div class="your_ins_price expenses">
						            <div class="text_icon d-block">
						            	<div class="d-flex">
						            		<div><p class="mb-1">Natinal Pension Scheme</p></div>
						            		<div><v-img max-height="15" max-width="15" :src="informationIcon" title="Enter current balance in your National Pension Scheme. You can use Auto Sync option to auto update your balance."></v-img></div>
						            	</div>
						            </div>
						            <div class="fields">
						                <v-text-field placeholder="₹ 0.00" v-model="currentValueOfRetirementSavingsNPS"  @input="changeTextFieldEvent($event)"></v-text-field>
						            </div>
						        </div>
						        <div class="your_ins_price expenses">
						            <div class="text_icon d-block">
						            	<div class="d-flex">
						            		<p class="mb-1">Equities/Mutual Fund/Deferred Pension/Insurance<div><v-img max-height="15" max-width="15" :src="informationIcon" title="Enter current fund balance in your holdings in Equities/Mutual Funds & Deferred Pension policies. You can use Auto Sync option to auto update your balance. Please select investment goals in your equities, mutual funds & deferred pension dashboards."></v-img></div></p>
						            	</div>
						            </div>
						            <div class="fields">
						                <v-text-field placeholder="₹ 0.00" v-model="currentValueOfRetirementSavingsEquityMutualFund"  @input="changeTextFieldEvent($event)"></v-text-field>
						            </div>
						        </div>
					        </div>
					        <div class="col-md-6 investments">
								<div class="info_box">
									<div class="income_title">
									  <h3>Current Monthly Savings in various retirement Schemes</h3>
									</div>
									<div class="income_date">
									  <!-- <p>Monthly</p> -->
									</div>
								</div>
								<div class="your_ins_price expenses">
						            <div class="text_icon d-flex">
						            	<p>Public Provident Fund/Deposits(FD,RD etc)<div><v-img max-height="15" max-width="15" :src="informationIcon" class="icon_tick" title="Enter current balance in your Public Provident Fund Account/Deposits like FD,RD etc. You can use Auto Sync option to auto update your balance."></v-img></div></p>
						            </div>
						            <div class="fields">
						                <v-text-field placeholder="₹ 0.00" v-model="currentSavingRunRatePerMonthPPF"  @input="changeTextFieldEvent($event)"></v-text-field>
						            </div>
					            </div>
						        <div class="your_ins_price expenses">
						            <div class="text_icon d-block">
						            	<div class="d-flex">
						            		<div><p class="mb-1">Employee Provident Fund</p></div>
						            		<div><v-img max-height="15" max-width="15" :src="informationIcon" title="Enter current monthly allocation in your Employee Provident Fund Account. You can use Auto Sync option to auto update your balance"></v-img></div>
						            	</div>
						            </div>
						            <div class="fields">
						                <v-text-field placeholder="₹ 0.00" v-model="currentSavingRunRatePerMonthEPF"  @input="changeTextFieldEvent($event)"></v-text-field>
						            </div>
						        </div>
						        <div class="your_ins_price expenses">
						            <div class="text_icon d-block">
						            	<div class="d-flex">
						            		<div><p class="mb-1">Natinal Pension Scheme</p></div>
						            		<div><v-img max-height="15" max-width="15" :src="informationIcon" title="Enter current monthly contribution in your National Pension Scheme. You can use Auto Sync option to auto update your balance"></v-img></div>
						            	</div>
						            </div>
						            <div class="fields">
						                <v-text-field placeholder="₹ 0.00" v-model="currentSavingRunRatePerMonthNPS"  @input="changeTextFieldEvent($event)"></v-text-field>
						            </div>
						        </div>
						        <div class="your_ins_price expenses">
						            <div class="text_icon d-block">
						            	<div class="d-flex">
						            		<p class="mb-1">Equities/Mutual Fund/Deferred Pension/Insurance<div><v-img max-height="15" max-width="15" :src="informationIcon" title="Enter current investments/premiums in your holdings in Equities/Mutual Funds & Deferred Pension policies. You can use Auto Sync option to auto update your balance"></v-img></div></p>
						            	</div>
						            </div>
						            <div class="fields">
						                <v-text-field placeholder="₹ 0.00" v-model="currentSavingRunRatePerMonthEquityMutualFund"  @input="changeTextFieldEvent($event)"></v-text-field>
						            </div>
						        </div>
					        </div>
					    </section>
				    </div>
					<v-dialog v-model="retirometer_score_dialog" width="900">
						<v-card class="secure-modal proceed-modal csv-file-modal riskmeter_main">
							<v-card-title class="text-h5" >Your&nbsp;<v-img  max-width="170" :src=" retirometerLogo" :lazy-src="retirometerLogo"> </v-img>&nbsp;Score card is shown below.</v-card-title>
							<v-card-text>
								<div class="row">
									<h4></h4>
					            	<div class="income_container">
					            		<div class="sync_detils">
								        </div>
									    <section class="your_income_section">
									        <div class="col-md-6">
										        <div class="info_box date-and-info">
										            <div class="income_title"></div>
										            <!-- <div class="income_date d-flex">
										              <p>Update/modify</p>
								                      <v-img max-height="22" max-width="20" :src="syncIcon" ></v-img>
										            </div> -->
										        </div>
									            <div class="your_ins_price expenses">
										            <div class="text_icon">
										            	<div><p>Your Desired Monthly Retirement Income from age {{retirementAge}} onwards</p></div>
										            </div>
										            <div class="fields">
										              <input type="text" name="" id="" placeholder="₹ 0.00" :value="formatPrice(yourDesiredRetirementIncome)" readonly />
										            </div>
									            </div>
									            <div class="your_ins_price expenses">
										            <div class="text_icon">
										            	<div><p>Your Projected Monthly Retirement Income from age {{retirementAge}} onwards</p></div>
										            </div>
										            <div class="fields">
										              <input type="text" name="" id="" placeholder="₹ 0.00" :value="formatPrice(neededProjectedMonthlyRetirementIncome)" readonly/>
										            </div>
									            </div>
									            <div class="your_ins_price expenses">
										            <div class="text_icon">
										            	<div><p>Your &nbsp;<b>RETIRO METER</b>&nbsp;Score</p></div>
										            </div>
										            <div class="fields">
										              <input type="text" name="" id="" placeholder="₹ 0.00" :value="retirometerScore" readonly/>
										            </div>
									            </div>
									        </div>
									        <div class="col-md-6 investments">
												<div class="info_box date-and-info">
													<div class="income_title">
													 <!--  <h3>{{lastModifiedDate}}</h3> -->
													</div>
													<div class="income_date d-flex">
										              <h3>Last Updated: {{lastModifiedDate}}</h3>
										            </div>
												</div>
												<div class="your_ins_price">
													<div class="text">
													  <p>Your Required Monthly Retirement Savings (A + B + C)</p>
													</div>
													<div class="fields">
													  <input type="text" name="" id="" placeholder="₹ 0.00" :value="formatPrice(neededMonthlyMonthlyRetirometer)" readonly />
													</div>
												</div>
												<div class="your_ins_price">
													<div class="text">
													  <p>A. Deposit Schemes (PPF, FD, RD, EPF etc)</p>
													</div>
													<div class="fields">
													  <input type="text" name="" id="" placeholder="₹ 0.00" :value="(formatPrice(neededPPF+neededEPF))" readonly />
													</div>
												</div>
												<!-- <div class="your_ins_price">
													<div class="text">
													  <p>Empolyee Provident</p>
													</div>
													<div class="fields">
													  <input type="text" name="" id="" placeholder="₹ 0.00" :value="formatPrice(neededEPF)" readonly />
													</div>
												</div> -->
												<div class="your_ins_price">
													<div class="text">
													  <p>B. National Pension Scheme</p>
													</div>
													<div class="fields">
													  <input type="text" name="" id="" placeholder="₹ 0.00" :value="formatPrice(neededNPS)" readonly />
													</div>
												</div>
												<div class="your_ins_price">
													<div class="text">
													  <p>C. Equity/Mutual Funds/Deferred Pension/Insurance</p>
													</div>
													<div class="fields">
													  <input type="text" name="" id="" placeholder="₹ 0.00" :value="formatPrice(neededEquityMFDeferred)" readonly />
													</div>
												</div>
									        </div>
									    </section>
									    <div class="income_container">
									    	<section class="your_income_section">
										        <div class="col-md-12">
												    <div class="terms-box">
												     	<p>{{message}}</p>
											        </div>
										        </div>
									        </section>
								        </div>
								    </div>
								</div>
					            <div class="riskMeter_btn" style="margin-left:20px"><br>
						            <v-btn type="submit" style="color: #051d42 !important; border-color: 1px solid #051d42 !important; height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;margin-right:12px" @click="proceed('investometer')"  
						              >INVESTOMETER</v-btn>
						            <v-btn type="submit" style="background-color: #051d42 !important;color: #fff !important;height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;" @click="proceed('proceed')"  
						              >PROCEED</v-btn>
						        </div>
							</v-card-text>
						</v-card>
					</v-dialog> 
	            </div>	
			    <span v-bind:class="{'error-messagebox-login': isAddClassServerError}" id="server_side_error" ></span>
			    <v-row class="buttonbox">
					<v-btn class="blue-border-btn" @click="backButton"> Cancel </v-btn>
					<v-btn class="blue-btn" @click="submit" :disabled="!isFormValid"> Calculate</v-btn>
			    </v-row>
			</v-form>
		</div>
	</div>
</template>
<script>
	import moment from 'moment'
	import Datepicker from 'vuejs-datepicker'
	import { validationMixin } from 'vuelidate'
	import {required, email, minLength, sameAs, isAlphanumeric, alpha, numeric, maxLength} from "vuelidate/lib/validators";
	import axios from 'axios';
	import VueSpeedometer from "vue-speedometer"
	import { Auth } from 'aws-amplify';
	import { isEmpty } from 'lodash';

	export default {
	    components: {
	      Datepicker,
	      VueSpeedometer
	    },
	    mixins: [validationMixin],
	    data: () => ({
			protectometerLogo: process.env.VUE_APP_ROOT_ICONS_URL + 'protectometer.svg',
			informationIcon:   process.env.VUE_APP_ROOT_ICONS_URL + 'information.svg',
			syncIcon:          process.env.VUE_APP_ROOT_ICONS_URL + 'sync.svg',
            retirometerLogo:   process.env.VUE_APP_ROOT_ICONS_URL + 'retirometer.svg',
			valid: true,
			submitted: false,
			activePicker: null,
			isAddClassServerError:false,
			menu: false,
			isFormValid:false,
			borderColor:'red',
			spikeValLife:150,
			protectometerMeterTextLife:'UNDERINSURED',
			spikeValHealth:150,
			protectometerMeterTextHealth:'HIGHLY UNDERINSURED',
			lastModifiedDate:'',
            loginMemberDob:'',
            loginMemberAge:'',
			mainMember:    '',
			mainMemberDob:'',
			mainMemberAge:'',
			getMembersObject:[],
			retirementAge:'',
			yearToRiterment:'',
            currentValueOfRetirementSavingsPPF:'',
			currentValueOfRetirementSavingsEPF:'',
			currentValueOfRetirementSavingsNPS:'',
			currentValueOfRetirementSavingsEquityMutualFund:'',
			currentSavingRunRatePerMonthPPF:'',
			currentSavingRunRatePerMonthEPF:'',
			currentSavingRunRatePerMonthNPS:'',
			currentSavingRunRatePerMonthEquityMutualFund:'',
			retirometer_score_dialog:false,
			disabledretirementAgeDates:{
			  to: new Date()
			},
			disabledDates: {
			  from: new Date()
			},
			yourDesiredRetirementIncome:'',
			allMemberList:[],
			neededDesiredMonthlyRetirementIncome:0,
			neededProjectedMonthlyRetirementIncome:0,
			retirometerScore:0,
			neededMonthlyMonthlyRetirometer:0,
			neededPPF:0,
			neededEPF:0,
			neededNPS:0,
			neededEquityMFDeferred:0,
			message:0,
			isSyncActivated: false,
			yourCurrentMonthlyIncome:''
	    }),

	    created (){
	    	Auth.currentAuthenticatedUser({
				bypassCache: false
			})
		    .then(user => {
		    	this.getMembersObject.push({'id':'0', 'name':user.attributes['custom:name']});
		    	this.loginMemberDob   = user.attributes['custom:birth'];
		    	this.loginMemberAge   = this.calculateAge(user.attributes['custom:birth']);
				let cognito_idp       = atob(localStorage.getItem('cognito_idp'));
				let formdata          = new FormData();
				formdata.append("aws_cognito_id", cognito_idp);
			    axios.post(process.env.VUE_APP_ROOT_API + "get-goalsure-family-list", formdata).then((response) => {
			    	this.allMemberList.push({'id':'0', 'name':user.attributes['custom:name'], 'is_dependent':'', 'monthly_expense':'', 'age':this.calculateAge(user.attributes['custom:birth']), 'member_type_id':'', 'dob':user.attributes['custom:birth']});
			    	this.member_type_items = response.data.member_type_list;
			    	response.data.data.forEach(memberItem=>{
		    	        this.getMembersObject.push({'id':memberItem.id, 'name':memberItem.name});
		    	        let memberAge      = this.calculateAge(memberItem.dob);
			    		memberItem.age     = (memberAge == 0)?1:memberAge;
			    		this.allMemberList.push(memberItem);
			    	});
			    });
		    });
		    if(this.$route.params.id){
		      setTimeout(()=>{this.setIfMemberAllreadyHaveData(this.$route.params.id);}, 1000);
		      this.isFormValid  = true;
		    }
	    },
	    
	    methods: {
	    	changeTextFieldEvent() {
		        this.isFormValid = this.$refs.form.validate()
		    },
	        calculateAge(dob){
	            let formated_dob = moment(String(dob)).format('DD MMM, yyyy')
	            let DOB          = new Date(formated_dob);  
	            let today        = new Date();
	            return today.getFullYear() - DOB.getFullYear();
	        },
	        calculateMainMemberAge(dob){
	            let formated_dob = moment(String(dob)).format('DD MMM, yyyy')
	            let DOB          = new Date(formated_dob);  
	            let today        = new Date();
	            this.mainMemberAge =  today.getFullYear() - DOB.getFullYear();
	        },
	    	backButton(){
	    		this.$router.push({ name: "ValueAddedServices", params: {}}).catch(()=>{}); 
	    	},
	    	submit(e){
	    		
                this.currentValueOfRetirementSavingsPPF = (this.currentValueOfRetirementSavingsPPF !='')?this.currentValueOfRetirementSavingsPPF:0;
                this.currentValueOfRetirementSavingsEPF = (this.currentValueOfRetirementSavingsEPF !='')?this.currentValueOfRetirementSavingsEPF:0;
                this.currentValueOfRetirementSavingsNPS = (this.currentValueOfRetirementSavingsNPS !='')?this.currentValueOfRetirementSavingsNPS:0;
                this.currentValueOfRetirementSavingsEquityMutualFund = (this.currentValueOfRetirementSavingsEquityMutualFund !='')?this.currentValueOfRetirementSavingsEquityMutualFund:0;


                this.currentSavingRunRatePerMonthEquityMutualFund = (this.currentSavingRunRatePerMonthEquityMutualFund !='')?this.currentSavingRunRatePerMonthEquityMutualFund:0;
                this.currentSavingRunRatePerMonthPPF = (this.currentSavingRunRatePerMonthPPF !='')?this.currentSavingRunRatePerMonthPPF:0;
                this.currentSavingRunRatePerMonthEPF = (this.currentSavingRunRatePerMonthEPF !='')?this.currentSavingRunRatePerMonthEPF:0;
                this.currentSavingRunRatePerMonthNPS = (this.currentSavingRunRatePerMonthNPS !='')?this.currentSavingRunRatePerMonthNPS:0;

	    		this.currentValueOfRetirementSavings = parseInt(this.currentValueOfRetirementSavingsPPF) + parseInt(this.currentValueOfRetirementSavingsEPF) + parseInt(this.currentValueOfRetirementSavingsNPS) + parseInt(this.currentValueOfRetirementSavingsEquityMutualFund);
	    		
	    		this.currentSavingRunRatePerMonth    = parseInt(this.currentSavingRunRatePerMonthEquityMutualFund) + parseInt(this.currentSavingRunRatePerMonthPPF) + parseInt(this.currentSavingRunRatePerMonthEPF) + parseInt(this.currentSavingRunRatePerMonthNPS);
	    		if(this.retirementAge < this.mainMemberAge){
                    swal.fire({
						title:              "Retirement year should be greater than main member age",
						showCancelButton:   false,
						confirmButtonColor: `#051d42`,
						confirmButtonText:  `Ok`,
						cancelButtonColor:  `#f19700`,
			        })
			        return false;
	    		}
	    		if(this.currentValueOfRetirementSavingsPPF == '' && this.currentValueOfRetirementSavingsEPF == '' && this.currentValueOfRetirementSavingsNPS     == '' && this.currentValueOfRetirementSavingsEquityMutualFund == '' && this.currentSavingRunRatePerMonthPPF == '' && this.currentSavingRunRatePerMonthEPF == '' && this.currentSavingRunRatePerMonthNPS == '' && this.currentSavingRunRatePerMonthEquityMutualFund == ''){
                     swal.fire({
						title: 'Enter data in "Current value of Retirement Savings" and "Current Monthly Savings in various retirement Schemes"',
						showCancelButton: false,
						confirmButtonColor: `#051d42`,
						confirmButtonText:  `Ok`,
						cancelButtonColor:  `#f19700`,
			        })
			        return false;
	    		}
	    		this.yearToRiterment = parseInt(this.retirementAge) - parseInt(this.mainMemberAge);
				let cognito_idp  = atob(localStorage.getItem('cognito_idp'));
				let formdata     = new FormData();
				formdata.append("aws_cognito_id", cognito_idp);
				formdata.append("mainMemberId",                       this.mainMember);
				formdata.append("mainMemberDob",                      this.mainMemberDob);
				formdata.append("mainMemberAge",                      this.mainMemberAge);
				formdata.append("retirementAge",                      this.retirementAge);
				formdata.append("yearToRiterment",                    this.yearToRiterment);
				formdata.append("currentMonthlyIncome",               this.currentMonthlyIncome);
				formdata.append("currentValueOfRetirementSavings",    this.currentValueOfRetirementSavings);
				formdata.append("currentValueOfRetirementSavingsPPF", this.currentValueOfRetirementSavingsPPF);
				formdata.append("currentValueOfRetirementSavingsEPF", this.currentValueOfRetirementSavingsEPF);
				formdata.append("currentValueOfRetirementSavingsNPS", this.currentValueOfRetirementSavingsNPS);
				formdata.append("currentValueOfRetirementSavingsEquityMutualFund", this.currentValueOfRetirementSavingsEquityMutualFund);
				formdata.append("currentSavingRunRatePerMonth",       this.currentSavingRunRatePerMonth);
				formdata.append("currentSavingRunRatePerMonthPPF",    this.currentSavingRunRatePerMonthPPF);
				formdata.append("currentSavingRunRatePerMonthEPF",    this.currentSavingRunRatePerMonthEPF);
				formdata.append("currentSavingRunRatePerMonthNPS",    this.currentSavingRunRatePerMonthNPS);
				formdata.append("currentSavingRunRatePerMonthEquityMutualFund", this.currentSavingRunRatePerMonthEquityMutualFund);
				formdata.append("yourDesiredRetirementIncome", this.yourDesiredRetirementIncome);
				formdata.append("currentMonthlyIncome", this.yourCurrentMonthlyIncome);
				
			    axios.post(process.env.VUE_APP_ROOT_API  + "post-retirometer", formdata).then((response) => {	
					this.neededProjectedMonthlyRetirementIncome=response.data.data.projected_monthly_retirement_income_per_month;
					this.retirometerScore=response.data.data.score+'%';
					this.neededMonthlyMonthlyRetirometer=response.data.data.required_monthly_retirement_savings;
					this.neededPPF=response.data.data.required_ppf;
					this.neededEPF=response.data.data.required_epf;
					this.neededNPS=response.data.data.required_nps;
					this.neededEquityMFDeferred=response.data.data.required_equity_mf;
					this.message=response.data.data.message;
					this.lastModifiedDate = response.data.lastModifiedBy
                    this.retirometer_score_dialog = true;
			    });		    		
	    	},
	    	proceed(e){
		        if(e == 'investometer'){
		          this.$router.push({ name: "Investometer", params: {}}).catch(()=>{});       
		        }
		        else{
		          this.$router.go(0);       
		        }
		    },
		    syncMemberData(){
		    	if(this.isSyncActivated == false){
		    		let cognito_idp  = atob(localStorage.getItem('cognito_idp'));
					let formdata     = new FormData();
					formdata.append("aws_cognito_id", cognito_idp);
					formdata.append("member_id", 0);
				    axios.post(process.env.VUE_APP_ROOT_API + "sync-detail-retirometer", formdata).then((response) => {
				    	this.currentValueOfRetirementSavingsPPF=response.data.data.current_value_for_retirement_savings_ppf;
						this.currentValueOfRetirementSavingsEPF=response.data.data.current_value_for_retirement_savings_epf;
						this.currentValueOfRetirementSavingsNPS=response.data.data.current_value_for_retirement_savings_nps;
						this.currentValueOfRetirementSavingsEquityMutualFund=response.data.data.current_value_for_retirement_savings_emi;
						this.currentSavingRunRatePerMonthPPF=response.data.data.current_value_for_monthly_savings_ppf;
						this.currentSavingRunRatePerMonthEPF=response.data.data.current_value_for_monthly_savings_epf;
						this.currentSavingRunRatePerMonthNPS=response.data.data.current_value_for_monthly_savings_nps;
						this.currentSavingRunRatePerMonthEquityMutualFund=response.data.data.current_value_for_monthly_savings_emi;
						this.isSyncActivated = true
				    });
		    	}
		    },
		    checkTerm(){
		        this.$router.push({ name: "FinStat", params: {}}).catch(()=>{});       
		    },
		    setIfMemberAllreadyHaveData(memberId){
                let cognito_idp  = atob(localStorage.getItem('cognito_idp'));
				let formdata     = new FormData();
				formdata.append("aws_cognito_id", cognito_idp);
				formdata.append("mainMemberId", memberId);
			    axios.post(process.env.VUE_APP_ROOT_API + "get-retirometer-detail", formdata).then((response) => {
			    	if(response.data.data.mainMemberId == 0){
			           this.mainMember                      = String(response.data.data.mainMemberId);	
			    	} 
			    	else{			    		
			           this.mainMember                      = parseInt(response.data.data.mainMemberId);	
			    	}
			        this.mainMemberDob                      = response.data.data.mainMemberDob;
			        this.mainMemberAge                      = response.data.data.mainMemberAge;
			        this.retirementAge                      = response.data.data.retirementAge;	
			        this.currentMonthlyIncome               = response.data.data.currentMonthlyIncome;	

			        this.currentValueOfRetirementSavingsPPF = response.data.data.currentValueOfRetirementSavingsPPF;
			        this.currentValueOfRetirementSavingsEPF = response.data.data.currentValueOfRetirementSavingsEPF;
			        this.currentValueOfRetirementSavingsNPS = response.data.data.currentValueOfRetirementSavingsNPS;
			        this.currentValueOfRetirementSavingsEquityMutualFund = response.data.data.currentValueOfRetirementSavingsEquityMutualFund;

			        this.currentSavingRunRatePerMonthPPF    = response.data.data.currentSavingRunRatePerMonthPPF;
			        this.currentSavingRunRatePerMonthEPF    = response.data.data.currentSavingRunRatePerMonthEPF;
			        this.currentSavingRunRatePerMonthNPS    = response.data.data.currentSavingRunRatePerMonthNPS;
			        this.currentSavingRunRatePerMonthEquityMutualFund    = response.data.data.currentSavingRunRatePerMonthEquityMutualFund;
			        this.yourDesiredRetirementIncome        = response.data.data.yourDesiredRetirementIncome;
			        this.yourCurrentMonthlyIncome           = response.data.data.currentMonthlyIncome;	
			    });
		    },
		    calculateYearToRetirement(e){
                this.yearToRiterment = e - this.mainMemberAge;
		    },
		    formatPrice(value) {
		        var formatter = new Intl.NumberFormat('en-US', {});
		        return formatter.format(value);
		    },

		    setMainMemberData(id){
	        	this.mainMember = id;
	        	let newMemberList = []
		    	this.allMemberList.forEach(memberItem=>{
		    		if(id == memberItem.id){
                   	   this.mainMemberDob = memberItem.dob;
	    	           this.mainMemberAge = memberItem.age;
                    }
	    		});
		    },
	    },
	};
</script>
<style scoped>
	.more_btn_class{
	  	background-color:#F19700 !important; 
	  	border-color:#F19700 !important; 
	  	min-width: 77px !important; 
	  	float:right; 
	  	margin-right: -4px !important; 
	  	height:30px !important;
	}

    .remove_btn_class{
	  	background-color:#f44336 !important; 
	  	border-color:#f44336 !important; 
	  	min-width: 77px !important; 
	  	float:right; 
	  	margin-right: -4px !important; 
	  	height:30px !important;
    }

    .add-new-memberbox .edit-profilebox-detail .row {
        max-width: 100%;
    }

    .income_container {
	    max-width: 1140px;
	    width: 100%;
	    margin: 0 auto;
	}

	.income_container .info_box {
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	}

	.income_container .income_title h3 {
	    font-size: 16px;
	    color: #1A407D;
	    max-width: 220px;
	    width: 100%;
	}

	.income_container .income_date {
	    min-width: 110px;
	}

	.income_container .income_date p {
	    color: #7D7D7D;
	}

	.income_container .your_income_section.row {
	    padding-top: 20px;
	    border-top: 1px solid #E5E5E5;
	    margin-top: 20px;
	}

	.income_container .sync_detils {
	    text-align: end;
	    padding-bottom: 40px;
	    position: relative;

	}

	.income_container .sync_detils span {
	    color: #1A407D;
	    border-bottom: 1px solid #1A407D;
	   
	}

	.income_container .your_ins_price {
	    display: flex;
	    justify-content: space-between;
	    padding-top: 20px;
	    align-items: center;
	}

	.income_container .your_ins_price p {
	    font-size: 15px;
	    color: #333333;
	    max-width: 230px;
	    width: 100%;
	    position: relative;
	}

	.your_ins_price.expenses p::after {
	    content: '';
	    height: 20px;
	    width: 20px;
	    background-size: contain;
	    background-repeat: no-repeat;
	    display: inline-block;
	    /* transform: translate(-50%,-50%); */
	    margin-left: 20px;
	    position: absolute;
	    top: 3px;
	}

	.your_ins_price.expenses span {
	    color: #7B7B7B;
	    font-size: 12px;
	}

	.col-md-6.investments {
	    border-left: 1px solid #E5E5E5;
	}

	.income_container input[type="text"] {
	    width: 111px;
	    height: 49px;
	    border: 1px solid #DDDDDD;
	    border-radius: 6px;
	    text-align: center;

	}

	.income_container .col-md-6.expenses {
	    padding-right: 30px;
	}

	.income_container .col-md-6 {
	    padding-right: 30px;
	    padding-left: 30px;
	}

	.income_container .proceed_btn button {
	    border: none;
	    padding: 13px 50px;
	    font-size: 15px;
	}

	.income_container .proceed_btn .btn1 {
	    border: 1px solid #051D42;
	    border-radius: 6px;
	    background-color: transparent;
	}

	.income_container .proceed_btn .btn_proceed {
	    background-color: #051D42;
	    color: white;
	    margin-left: 20px;
	}

	.proceed_btn .btn_cancel:hover {
	    background-color: #051D42;
	    color: white;
	    transition: .3s ease all;
	}

	.proceed_btn .btn_proceed:hover {
	    background-color: transparent;
	    color: black;
	    transition: .3s ease all;
	}

	.income_container .sync_detils span::after{
	    content: '';
	    height: 20px;
	    width: 20px;
	    background-size: contain;
	    background-repeat: no-repeat;
	    display: inline-block;
	    margin-left: 5px;
	    position: absolute;
	    top: 3px;    
	}

	section.your_income_section {
	    display: flex;
	}
	.add-new-memberbox .row.buttonbox {
	    margin-bottom: 25px !important;
	    margin-top: 50px !important;
	}
	.text_icon {
	    display: flex;
	    justify-content: space-between;
	}
	.icon_tick{
	    margin-left: 8px;
	    margin-top: 2px;
	}
	.info_box.date-and-info {
	    font-size: 14px;
	}

	.info_box.date-and-info h3 {
	    font-size: 14px !important;
	    color: #818181 !important;
	    font-weight: 500;
	}

	.info_box.date-and-info p {
	    margin: 0;
	    color: #818181 !important;
	    font-weight: 400;
	    margin-right: 5px;
	}
	span.percent-num {
	    font-size: 20px !important;
	    color: #1A407D !important;
	}	
	.terms-box {
	    background: #F3F3F3;
	    padding: 15px 20px;
	    margin-top: 20px;
	}
	.sync_detils.main-sync-heading {
	    display: flex;
	    align-items: center;
	    justify-content: flex-end;
	}

	.sync_detils.main-sync-heading span {
	    border: none !important;
	    margin-right: 5px;
	}

	.member_relation_box.col.member_dob.col-md-2.col {
	    position: relative;
	}
	.dob-box1 ::before {
	    content: "";
	    position: absolute;
	    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAZVJREFUOBGtlO9xgkAQxeVPAXRgHP2uqQBSQUpIOhEriSkhFUQrCPmOoyXQAJLfIxzDBSeeyM4cu/d297G3tzCZdORwOKSs6ng8Jh34X1OxylFuNzDUBmeEWp7P56n26CVYJfuaKLaJmZITY3/PZrPCY7PC+Qkg8jGk8H3/KYR0C5tIN1VVJZ7nxeh39AnsqhD7QOwLeo/ekbCG822i/uR5LkD23T0WlzjrHotUwhG2qB0rY7lKpqMTfOomeGIHKDjKLWRdDsumHSuAyFQcASRWxJ2bmliNXywWoxCrxxQZm4rr+nR5GNV8Pt8whgm3G9O/PXOpC3Hy1UQ8fGM0eo1OZUOaoNJGC3LyKVBiVcx+U6M8qHQHaa0bzMln8jW77Ry34B2GmWOrFXqJlnjV02afNnsnn2IlFvEvNNJTVZlPegxK0wrr8nR8yG8et0sF/W2F00hdGMUet1UxXqeRujCKPWLzE8r42h573gEA7dTPbBnyn/jg234G+MIuBnC1KfBEIhVnGATBa1mWW5Gz2qChhkjF+QMBIlHMGk2p1wAAAABJRU5ErkJggg==);
	    width: 25px;
	    height: 25px;
	    right: 2px !important;
	    top: 10px !important;
	    pointer-events: none;
	}


</style>